import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { 
  kadblDaLiJeDefinisanaVisinaZaradeOK
  , kadblDaLiJeZaNepunoRadnoVremePrcAngOK
  , kadblDaLiJeZaPunoRadnoVremePrcAngOK 
} from "src/app/kad.bl/angazovanje-ro.bl";

export class AngazovanjeRoValidators{

  valPeriodAngazovanja(mainThis: any): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      return null;
    }
  }

  valAneksUOdnosuNaUgovor(mainThis: any): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      if (mainThis.Ugovor && mainThis.Ugovor.ID && mainThis.Ugovor.ID>0) {
        
      }
      return null;
    }
  }

  valRadnoVremePrcAng(mainThis: any): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      if (mainThis.radnoVremeItems){
        let _radnoVremeGenericName=mainThis.radnoVremeItems.find(x => x["ID"] ==mainThis.baseFormGroup.controls.RadnoVremeID.value)["GenericName"]
  
        // let _radnoVremeGenericName=mainThis.RadnoVremeGenericName;
        let _prcAng=mainThis.baseFormGroup.controls.PrcAng.value;
    
        if (_radnoVremeGenericName=="PUNO" ){
          if (!kadblDaLiJeZaPunoRadnoVremePrcAngOK(_prcAng)){
            return {'RadnoVremePrcAng' : 
              {valid: false
               , message: "ANGAZOVANJERO.VALIDATION.RADNOVREMEPUNOPRCANG100" 
              }
            }
          }
        } else {
          if (_radnoVremeGenericName=="NEPUNO"){
            if (!kadblDaLiJeZaNepunoRadnoVremePrcAngOK(_prcAng)){
              return {'RadnoVremePrcAng' : 
                {valid: false
                , message: "ANGAZOVANJERO.VALIDATION.RADNOVREMENIJEPUNOPRCANGDO100" 
                }
              }
            }
          }
        }
      }
      return null;
    }
  }

  valCenaRada(mainThis: any):ValidatorFn{
    return (control: FormGroup): ValidationErrors | null => {
      if (
        !kadblDaLiJeDefinisanaVisinaZaradeOK(
          mainThis.baseFormGroup.controls.KoefZarade.value
          , mainThis.baseFormGroup.controls.NetoZarada.value
          , mainThis.baseFormGroup.controls.BrutoZarada.value
          , mainThis.baseFormGroup.controls.NetoCenaSata.value
          , mainThis.baseFormGroup.controls.BrutoCenaSata.value
        )
      ){
        return {'CenaRada' : 
          {valid: false
          , message: "ANGAZOVANJERO.VALIDATION.CENARADA" 
          }
        }
      }
      return null;
    }
  }
}
